import { Component, OnInit, Input } from '@angular/core';
import { FileService } from '../../../shared/_services/file.service'
import { MissingData } from '../../../shared/models/missingdata.model'

@Component({
  selector: 'app-load-file',
  templateUrl: './load-file.component.html',
  styleUrls: ['./load-file.component.css']
})
export class LoadFileComponent implements OnInit {

  @Input() missingData: MissingData;
  fileSelected = null;
  public progress: number;
  public message: string;
  error: string;

  // filename: string; // xls file variable
  constructor(private fileUploadService: FileService) { }

  ngOnInit() {  
  }
  /*
  upload(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (let file of files)
      formData.append(file.name, file);


    this.fileUploadService.uploadFile(formData).subscribe((res: any) => {
      if (res.body) {
        //Proceso para continuar Cargando informacion
        this.missingData = res.body;
        console.log(this.missingData.listMissingAgents);
      } else {
        //proceso finalizar cargue
        this.message = res.message;
      }
 
    },
      err => this.error = err
    );
  }*/

}
